import {
    Advisor,
    AdvisorConfiguration,
    AdvisorPluginContext,
    AdvisorWebDesignPlugin
} from "@zoovu/runner-browser-api";
import {isScrollingDisabledThroughDataAttribute, scrollMarginTop} from "./webdesign-context";

export enum ContainerDataAttribute {
    SCROLL_BEHAVIOR = "data-scroll-behavior",
    SCROLL_MARGIN_TOP = "data-scroll-margin-top"
}

export enum ScrollBehavior {
    NO_SCROLL = "noscroll"
}

export class DataAttributesReaderPlugin implements AdvisorWebDesignPlugin {

    public async beforeMount(advisor: Advisor, advisorConfiguration: AdvisorConfiguration, advisorPluginContext: AdvisorPluginContext): Promise<void> {
        const container = document.getElementById(advisorPluginContext.advisorConfiguration.advisorUiConfiguration.containerDivId);

        if (container) {
            /**
             * @deprecated
             * scrollBehaviour data attribute is just there for backwards compatibility - it can now be set in "appearance tab"
             */
            const dataScrollBehavior = container.getAttribute(ContainerDataAttribute.SCROLL_BEHAVIOR);
            const dataScrollMarginTop = container.getAttribute(ContainerDataAttribute.SCROLL_MARGIN_TOP);
            const scrollMarginTopValue = !isNaN(parseInt(dataScrollMarginTop, 10)) ? parseInt(dataScrollMarginTop, 10) : 0;

            // @ts-ignore
            isScrollingDisabledThroughDataAttribute = !!dataScrollBehavior &&
                dataScrollBehavior === ScrollBehavior.NO_SCROLL;
            // @ts-ignore
            scrollMarginTop = scrollMarginTopValue;
        }
    }
}
